'use strict';
import './widgets/formBuilder';
import './widgets/arrayField';
import './widgets/dateRangePicker';
import './widgets/dateTimeRangePicker';
import './widgets/dropDownPanel';
import './widgets/submitButton';
import {register} from './types/index';
import allTypes from './types/allTypes';
register(allTypes);


// WEBPACK FOOTER //
// ./src/entry.js